import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {CommunicationContentModelDataService} from './communicationContentModelData.service';
import {CommunicationContentModelSummaryModel} from '../../../api/entity/communicationContentModelSummary.model';
import {
    CommunicationContentModelSummaryConverter
} from '../../../api/entity/converter/communicationContentModelSummary.converter';
import {CommunicationContentModelModel} from '../../../api/entity/communicationContentModel.model';

@Injectable()
export class CommunicationContentModelSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<CommunicationContentModelSummaryModel,
        CommunicationContentModelSummaryConverter,
        CommunicationContentModelModel> {
    constructor(dataService: CommunicationContentModelDataService, converter: CommunicationContentModelSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): CommunicationContentModelModel {
        return new CommunicationContentModelModel();
    }
}
